import { gql } from "@apollo/client";

export const GET_PANTALLAS_RI = gql`
  query PantallasRI {
    pantallasRI {
        idPantallaRI
        pantalla
        idTipoModulo{
          idTipoModulo
          abreviacion
        }
    }
}`;